/* eslint-disable */
import ThemeSwitcher from '../components/ThemeSwitcher';
// AUTO-GENERATED from /sector-patrol by scripts/html2jsx.mjs — markup preserved 1:1.
export const bodyClass = "bg-slate-950 text-slate-100 h-screen flex flex-col overflow-hidden font-sans";

export default function SectorMarkup() {
  return (
    <>
      {/* TOP HEADER */}
      <header className="bg-slate-900 border-b border-slate-800 px-4 py-2 flex items-center justify-between shrink-0 shadow-md h-16">
        {/* 1. IDENTITY & SECTOR COMMAND BRANDING */}
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-tr from-indigo-700 to-blue-600 flex items-center justify-center text-white shadow-lg text-xl font-bold shrink-0 border border-indigo-400/30">
            🚓
          </div>
          <div>
            <div className="flex items-center gap-2">
              <h1 className="text-sm font-black text-white flex items-center gap-2 uppercase tracking-tight">
                Travelling Superior Live Tracking{' '}
                <span className="text-[9px] bg-indigo-500/10 text-indigo-400 border border-indigo-500/30 px-2 py-0.5 rounded-full font-black">
                  LIVE ROUTE ACTIVE
                </span>
              </h1>
            </div>
            <p className="text-[11px] text-slate-400">
              DSP • Circle Inspector • Sub-Inspector SHO • Station-to-Station Live Moving Supervision
            </p>
          </div>
        </div>
        {/* 2. ICONS-WISE PORTAL NAVIGATION BAR (Proper Website Style) */}
        <nav className="hidden lg:flex items-center bg-slate-950 p-1 rounded-xl border border-slate-800 text-xs font-semibold shadow-inner">
          <a href="/admin" className="px-3 py-1.5 text-slate-300 hover:text-white hover:bg-slate-900 rounded-lg transition flex items-center gap-1.5">
            <span>
              🗺️
            </span>
            <span>
              Live Map
            </span>
          </a>
          <a href="/emergency-sos" className="px-3 py-1.5 text-slate-300 hover:text-white hover:bg-slate-900 rounded-lg transition flex items-center gap-1.5">
            <span>
              🚨
            </span>
            <span>
              Incident Grid
            </span>
          </a>
          <span className="px-3 py-1.5 bg-indigo-600 text-white rounded-lg font-bold shadow flex items-center gap-1.5 cursor-default">
            <span>
              🚓
            </span>
            <span>
              Sector Patrol
            </span>
          </span>
          <a href="/officer-app" className="px-3 py-1.5 text-slate-300 hover:text-white hover:bg-slate-900 rounded-lg transition flex items-center gap-1.5">
            <span>
              📱
            </span>
            <span>
              Staff App
            </span>
          </a>
        </nav>
        {/* 3. CONTROLS, PROFILE, TOOLS & LOGOUT */}
        <div className="flex items-center gap-2">
          {/* Profile Selector */}
          <div className="flex items-center gap-1.5 bg-slate-950 px-2 py-1 rounded-lg border border-slate-800 text-xs">
            <label className="text-[11px] text-indigo-400 font-bold shrink-0">
              Officer:
            </label>
            <select id="supervisor-profile-select" className="bg-slate-900 border border-slate-700 text-xs text-white rounded px-2 py-0.5 focus:outline-none max-w-[170px] truncate">
              {/* Populated dynamically */}
            </select>
          </div>
          {/* LIVE MOVING ANIMATION BUTTON */}
          <button id="btn-travel-toggle" onClick={(event) => { startLiveMovingPatrol() }} className="px-3 py-1.5 bg-gradient-to-r from-indigo-600 to-blue-600 hover:from-indigo-500 hover:to-blue-500 text-white rounded-lg text-xs font-bold shadow-lg transition flex items-center gap-1.5 animate-pulse">
            <span>
              🚗
            </span>
            {' '}
            <span className="hidden sm:inline">
              Start
            </span>
            {' '}Moving Patrol
          </button>
          {/* Tools Dropdown */}
          <div className="relative inline-block text-left" id="header-tools-dropdown-container">
            <button type="button" id="btn-tools-dropdown" onClick={(event) => { toggleHeaderToolsDropdown(event) }} className="px-2.5 py-1.5 bg-slate-800 hover:bg-slate-700 text-slate-200 hover:text-white text-xs font-bold rounded-lg border border-slate-700 shadow flex items-center gap-1 transition cursor-pointer">
              <span>
                ⚡
              </span>
              <span className="hidden md:inline">
                Tools
              </span>
              <span className="text-[9px] text-slate-400">
                ▼
              </span>
            </button>
            <div id="header-tools-dropdown" className="hidden absolute right-0 mt-2 w-64 rounded-2xl bg-slate-900 border border-slate-700 shadow-2xl z-50 p-2 text-xs divide-y divide-slate-800">
              <div className="py-1">
                <button type="button" onClick={(event) => { openUploadModal('BOOTHS'); closeHeaderToolsDropdown(); }} className="w-full text-left px-3 py-2 rounded-xl text-slate-200 hover:text-white hover:bg-slate-800 flex items-center gap-2 transition">
                  <span>
                    📤
                  </span>
                  {' '}Upload Roster CSV
                </button>
                <button type="button" onClick={(event) => { openApkModal(); closeHeaderToolsDropdown(); }} className="w-full text-left px-3 py-2 rounded-xl text-slate-200 hover:text-white hover:bg-slate-800 flex items-center gap-2 transition">
                  <span>
                    📲
                  </span>
                  {' '}Staff Android APK
                </button>
              </div>
            </div>
          </div>
          {/* Pleasant Theme Switcher */}
          <ThemeSwitcher className="mr-0.5" labelClass="hidden xl:inline" />
          <a href="/login" title="Logout" className="w-8 h-8 rounded-lg bg-slate-800 hover:bg-red-900/40 text-slate-300 hover:text-red-300 border border-slate-700 flex items-center justify-center text-sm transition">
            🚪
          </a>
        </div>
      </header>
      {/* OFFICER PROFILE & KPI BAR */}
      <div className="bg-slate-900/80 border-b border-slate-800 px-4 py-2 shrink-0 flex items-center justify-between text-xs">
        <div className="flex items-center gap-4">
          <div>
            <div id="profile-name" className="text-xs font-bold text-white uppercase tracking-wider">
              Inspector Vikram Singh
            </div>
            <div id="profile-rank" className="text-[11px] text-indigo-400 font-medium">
              Circle Inspector (CI-201)
            </div>
          </div>
          <div className="h-6 w-px bg-slate-800"></div>
          <div id="profile-jurisdiction" className="text-[11px] text-slate-300">
            Circle: Secretariat Circle
          </div>
          <div className="h-6 w-px bg-slate-800"></div>
          <div id="profile-vehicle" className="text-[11px] text-slate-300 font-mono">
            Vehicle: KA-01-CI-01
          </div>
          <div className="h-6 w-px bg-slate-800"></div>
          <div id="profile-phone" className="text-[11px] text-slate-300 font-mono">
            Phone: +91 98765 12001
          </div>
        </div>
        {/* Live KPI Counters */}
        <div className="flex items-center gap-2 font-mono text-xs">
          <div className="bg-slate-800 px-2 py-1 rounded border border-slate-700">
            Booths:{' '}
            <strong id="stat-my-booths" className="text-white">
              --
            </strong>
          </div>
          <div className="bg-slate-800 px-2 py-1 rounded border border-slate-700">
            My Men:{' '}
            <strong id="stat-my-men" className="text-indigo-300">
              --
            </strong>
          </div>
          <div className="bg-emerald-950/40 px-2 py-1 rounded border border-emerald-600/40 text-emerald-300">
            At Booth:{' '}
            <strong id="stat-my-onsite">
              --
            </strong>
          </div>
          <div className="bg-amber-950/40 px-2 py-1 rounded border border-amber-600/40 text-amber-300">
            Away:{' '}
            <strong id="stat-my-away">
              --
            </strong>
          </div>
          <div className="bg-rose-950/40 px-2 py-1 rounded border border-rose-600/40 text-rose-300">
            Absent:{' '}
            <strong id="stat-my-absent">
              --
            </strong>
          </div>
          <div className="bg-red-950/40 px-2 py-1 rounded border border-red-600/40 text-red-400">
            🚨 SOS:{' '}
            <strong id="stat-my-sos">
              --
            </strong>
          </div>
        </div>
      </div>
      {/* MAIN SPLIT VIEW */}
      <div className="flex-1 flex overflow-hidden">
        {/* LEFT: MAP SHOWING LIVE MOVING VEHICLE */}
        <div className="flex-1 relative bg-slate-950">
          <div id="sector-map" className="w-full h-full"></div>
          {/* Traveling Guidance Strip */}
          <div className="absolute bottom-6 left-6 z-[1000] bg-slate-900/90 backdrop-blur-md border border-slate-700/80 p-3 rounded-xl shadow-2xl text-xs space-y-1">
            <div className="text-[11px] font-bold text-white flex items-center gap-2">
              <span className="w-4 h-4 rounded bg-indigo-700 text-white flex items-center justify-center text-[10px]">
                🚓
              </span>
              {' '}Live Moving Patrol Route
            </div>
            <div className="text-[10px] text-slate-400">
              Numbered pins show all polling booths under your charge. Click "Start Live Moving Patrol" to see animated vehicle travel!
            </div>
          </div>
        </div>
        {/* RIGHT: TABS (BOOTHS, MEN, EMERGENCY ALERTS) */}
        <aside className="w-[500px] bg-slate-950 border-l border-slate-800 flex flex-col shrink-0">
          {/* TABS HEADER */}
          <div className="p-2 bg-slate-900 border-b border-slate-800 flex gap-1.5">
            <button id="tab-btn-booths" onClick={(event) => { switchTab('BOOTHS') }} className="flex-1 py-1.5 bg-indigo-600 text-white font-bold rounded-lg transition text-xs">
              🗳️ Polling Booths
            </button>
            <button id="tab-btn-men" onClick={(event) => { switchTab('MEN') }} className="flex-1 py-1.5 text-slate-400 hover:text-white font-medium rounded-lg transition text-xs">
              👮 My Men on Duty
            </button>
            <button id="tab-btn-alerts" onClick={(event) => { switchTab('ALERTS') }} className="flex-1 py-1.5 text-slate-400 hover:text-white font-medium rounded-lg transition text-xs flex items-center justify-center gap-1">
              <span>
                🚨
              </span>
              {' '}Emergency Pings
            </button>
          </div>
          {/* LIST CONTAINER */}
          <div id="list-container" className="flex-1 overflow-y-auto p-3 space-y-2">
            {/* Injected dynamically by sector.js */}
          </div>
          {/* PHYSICAL INSPECTION LOGS */}
          <div className="border-t border-slate-800 p-3 bg-slate-900/90 shrink-0 space-y-1.5 max-h-44 flex flex-col">
            <div className="flex items-center justify-between">
              <span className="text-xs font-bold text-slate-300 flex items-center gap-1.5">
                <span>
                  📝
                </span>
                {' '}Physical Booth Inspection History
              </span>
              <span className="text-[10px] text-slate-500">
                Live Synced to HQ
              </span>
            </div>
            <div id="inspection-logs-container" className="overflow-y-auto space-y-1 flex-1 pr-1">
              {/* Injected dynamically */}
            </div>
          </div>
        </aside>
      </div>
      {/* APPLICATION SCRIPTS */}
    </>
  );
}
